<template>
  <div class="modal" v-bind:class="{ 'is-active': imageModalView }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ modalTitle }}</p>
      </header>
      <section class="modal-card-body">
        <div class="content">
          <slot></slot>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button @click="$emit('close')" class="button">Cancel</button>
        <button
          @click="changeLoad()"
          class="button"
          v-bind:class="[{ 'is-loading': isLoad }, buttonColor]"
        >
          {{ modalAction }}
        </button>
      </footer>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
export default {
  props: {
    imageModalView: {
      type: Boolean,
      require: true,
    },
    modalTitle: {
      type: String,
      require: true,
    },
    modalAction: {
      type: String,
      require: true,
    },
    buttonColor: {
      type: String,
      require: false,
      default: "is-danger",
    },
  },
  setup(_, context) {
    const isLoad = ref(false);
    const changeLoad = () => {
      isLoad.value = true;
      context.emit("doAction");
      isLoad.value = false;
    };
    return {
      isLoad,
      changeLoad,
    };
  },
};
</script>
